import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { CircleDollarSign, FlaskConical, PlusIcon } from 'lucide-react';
import { ExperimentListing } from './components/ExperimentListings';
import { NewExperimentDrawer } from './components/NewExperimentDrawer';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuGroup, DropdownMenuContent } from '@/components/ui/dropdown-menu';


export type ManageExperimentsProps = {
  organizationId: string;
};

export const ManageExperiments = ({
  organizationId,
}: ManageExperimentsProps) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const org = useStore($org);

  const pages = [
    {
      label: org?.name ?? 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/experiments`
        : '/organizations',
    },
    {
      label: 'Experiments',
      href: `/organization/${org?.id ?? ''}/experiments`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Experiments</h2>
          <p className="text-muted-foreground">
            {`List of experiments for ${org?.name}.`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
            <Button onClick={() => setShowDrawer(true)}>
                <PlusIcon className="mr-2 h-4 w-4" /> Add New
            </Button>
        </div>  
      </div>

      {/* Experiment list*/}
      <div className="mt-4 max-w-4xl">
        <ExperimentListing />
      </div>

      {/* Create New Experiment Drawer */}
      <NewExperimentDrawer open={showDrawer} setOpen={setShowDrawer} />
    </div>
  );
};